<div class="modal-body blu-border">
  <div
    class="row container"
    [ngClass]="{ 'display-none': contactFlag === true }"
  >
    <div class="col-sm-12 col-md-6">
      <p>{{ dialogData.data.para1 }}</p>
      <button class="btn btn-primary" (click)="openChat()">
        {{ (formLabels?.buttons)[0].keyText }}
      </button>
    </div>
    <div class="col-sm-12 col-md-6">
      <p>{{ dialogData.data.para2 }}</p>
      <button class="btn btn-primary" (click)="openContactForm('contact')">
        {{ (formLabels?.buttons)[1].keyText }}
      </button>
    </div>
  </div>

  <div class="container" *ngIf="contactFlag">
    <form
      [formGroup]="contactUsForm"
      (ngSubmit)="onSubmit()"
      id="help-support"
      [action]="actionUrl[0].fieldInfo.fieldValue"
      method="post"
    >
      <input
        type="hidden"
        [name]="debug[0].fieldInfo.fieldName"
        [value]="debug[0].fieldInfo.fieldValue"
      />
      <input
        type="hidden"
        [name]="orgid[0].fieldInfo.fieldName"
        [value]="orgid[0].fieldInfo.fieldValue"
      />
      <input type="hidden" name="retURL" [value]="contactUsReturnUrl" />
      <div class="form-row">
        <div class="col-sm-12 col-md-6 frm-field">
          <label for="name">{{ formFields?.nameField?.fieldInfo.label }}</label>
          <input
            id="name"
            name="name"
            type="text"
            maxlength="80"
            tabindex="1"
            formControlName="name"
            class="form-control ng-untouched ng-pristine ng-invalid is-invalid"
            [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
          />

          <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
            <div *ngIf="f.name.errors.required">
              {{ formFields?.nameField?.fieldInfo.label }}
              {{ f.name['requiredError'] }}
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 frm-field">
          <label for="email">{{
            formFields?.emailField?.fieldInfo.label
          }}</label>
          <input
            id="email"
            name="email"
            type="text"
            maxlength="80"
            tabindex="2"
            formControlName="email"
            class="form-control ng-untouched ng-pristine ng-invalid is-invalid"
            [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
          />

          <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
            <div *ngIf="f.email.errors.required">
              {{ formFields?.emailField?.fieldInfo.label }}
              {{ f.email['requiredError'] }}
            </div>
            <div *ngIf="f.email.errors.email">
              {{ f.email['validEmailError'] }}
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 frm-field">
          <label for="phone">{{
            formFields?.telephoneField?.fieldInfo.label
          }}</label>
          <input
            id="phone"
            name="phone"
            type="text"
            tabindex="3"
            formControlName="telephone"
            [value]="f.telephone.value | formatNumber"
            (keypress)="numberOnly($event)"
            class="form-control ng-untouched ng-pristine ng-invalid is-invalid"
            [ngClass]="{ 'is-invalid': submitted && f.telephone.errors }"
          />

          <div *ngIf="submitted && f.telephone.errors" class="invalid-feedback">
            <div *ngIf="f.telephone.errors.required">
              {{ formFields?.telephoneField?.fieldInfo.label }}
              {{ f.telephone['requiredError'] }}
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 frm-field">
          <label for="policyid">{{
            formFields?.policySubmissionField?.fieldInfo.label
          }}</label>
          <input
            type="text"
            id="policyid"
            name="Policy_Submission_Number__c"
            formControlName="policyNumber"
            maxlength="20"
            (keypress)="numberOnly($event)"
            tabindex="4"
            class="form-control ng-untouched ng-pristine ng-invalid is-invalid"
            [ngClass]="{ 'is-invalid': submitted && f.policyNumber.errors }"
          />

          <div
            *ngIf="submitted && f.policyNumber.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.policyNumber.errors.required">
              {{ formFields?.policySubmissionField?.fieldInfo.label }}
              {{ f.policyNumber['requiredError'] }}
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 frm-field">
          <label for="subject">{{
            formFields?.assistanceField?.fieldInfo.label
          }}</label>
          <select
            id="subject"
            name="subject"
            tabindex="5"
            formControlName="assistance"
            class="form-control ng-untouched ng-pristine ng-invalid is-invalid"
            [ngClass]="{ 'is-invalid': submitted && f.assistance.errors }"
          >
            <option value="">{{ (formLabels?.dropdown)[0]?.heading }}</option>
            <option
              [value]="items.keyText"
              *ngFor="let items of (formLabels?.dropdown)[0].displayItems"
              >{{ items.keyText }}</option
            >
          </select>
          <div
            *ngIf="submitted && f.assistance.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.assistance.errors.required">
              {{ formFields?.assistanceField?.fieldInfo.label }}
              {{ f.assistance['requiredError'] }}
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-10 frm-field">
          <label for="description">{{
            formFields?.issueDetailField?.fieldInfo.label
          }}</label>
          <textarea
            id="description"
            name="description"
            formControlName="issueDetail"
            maxlength="500"
            tabindex="6"
            rows="5"
            class="form-control ng-untouched ng-pristine ng-invalid is-invalid"
            [ngClass]="{ 'is-invalid': submitted && f.issueDetail.errors }"
          ></textarea>

          <div
            *ngIf="submitted && f.issueDetail.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.issueDetail.errors.required">
              {{ formFields?.issueDetailField?.fieldInfo.label }}
              {{ f.issueDetail['requiredError'] }}
            </div>
          </div>
        </div>
      </div>
      <div class="right-align">
        <button type="button" class="btn btn-primary cancel" (click)="cancel()">
          {{ (formLabels?.buttons)[2]?.keyText }}
        </button>
        <button class="btn btn-primary send" type="submit">
          {{ (formLabels?.buttons)[3]?.keyText }}
        </button>
      </div>
    </form>
  </div>
</div>
